







import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PurchasedItem } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import { isAudioFile } from "@/lib/fileHelpers";
import { ProcessedFileData } from "@/types";
import AudioList from "@/components/AudioList";
import PurchasedItemBase from "./components/PurchasedItemBase.vue";
import PurchaseGalleryItemFiles from "./components/PurchaseGalleryItemFiles.vue";

export default defineComponent({
  name: "MediaPostView",
  components: { AudioList, PurchaseGalleryItemFiles, PurchasedItemBase },
  props: {
    item: { type: Object as PropType<PurchasedItem>, required: true },
  },
  setup(props) {
    const nonAudioFiles = computed(() => props.item.files.filter(file => !isAudioFile(file)));
    const audioFiles = computed<ProcessedFileData>(() => {
      const audio = props.item.files.filter(file => isAudioFile(file));
      return {
        locked: [],
        accessed: audio,
        all: audio,
      };
    });

    return { nonAudioFiles, audioFiles };
  },
});
